<script>
import resources from './resources'

export default {
  name: 'gadget-professional',

  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Bem-vindo(a) ao Medibook!", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          statistics-agendas
          active-agenda(v-if="!user.settings.notify.integration.offline")
          schedulings-offline(v-if="user.settings.notify.integration.offline")
          agendas-statistics
          summary-billing(v-if="!userIsEmployee")
          abstract-speciality
</template>



// WEBPACK FOOTER //
// src/app/professional/dashboard/company/gadget/index.vue